var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.657 24.657L21.414 28.9C21.2284 29.0858 21.0081 29.2331 20.7656 29.3336C20.523 29.4342 20.2631 29.4859 20.0005 29.4859C19.738 29.4859 19.478 29.4342 19.2354 29.3336C18.9929 29.2331 18.7726 29.0858 18.587 28.9L14.343 24.657C13.2242 23.5382 12.4623 22.1127 12.1537 20.5609C11.845 19.009 12.0035 17.4005 12.609 15.9387C13.2145 14.477 14.2399 13.2276 15.5555 12.3485C16.8711 11.4695 18.4178 11.0003 20 11.0003C21.5822 11.0003 23.1289 11.4695 24.4445 12.3485C25.7601 13.2276 26.7855 14.477 27.391 15.9387C27.9965 17.4005 28.155 19.009 27.8463 20.5609C27.5377 22.1127 26.7758 23.5382 25.657 24.657V24.657Z",
    stroke: "#AEC6E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 21.1213C22.6839 20.5587 23 19.7956 23 19C23 18.2044 22.6839 17.4413 22.1213 16.8787C21.5587 16.3161 20.7956 16 20 16C19.2044 16 18.4413 16.3161 17.8787 16.8787C17.3161 17.4413 17 18.2044 17 19C17 19.7956 17.3161 20.5587 17.8787 21.1213C18.4413 21.6839 19.2044 22 20 22C20.7956 22 21.5587 21.6839 22.1213 21.1213Z",
    stroke: "#AEC6E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/menu-3.467e796ebb087ed8912fac083fa08bf6.svg";
export { ForwardRef as ReactComponent };